import React, {ReactNode} from 'react';
import styled from "styled-components";
import {Text18, Text24W700} from "../Typography";
import {NavLink} from "react-router-dom";
import {Button} from "../Button";
import DateChip from "../DateChip";

interface NewsCardRootProps {
    className?: string;
    children: ReactNode;
}

const NewsCardRoot = ({className, children}: NewsCardRootProps) => (
    <Article className={className}>{children}</Article>
);

const Article = styled.article`
    display: flex;
    flex-direction: column;
    gap: 12px;
    background-color: #F5F8FB;
    border-radius: 16px;
    padding: 24px;
    white-space: pre-wrap;
`;

const Header = styled.div`
    display: flex;
    gap: 25px;
    justify-content: space-between;
`;

const Logos = styled.div`
    display: flex;
    gap: 31px;
    
    @media (max-width: 768px) {
        gap: 12px;
    }
`;

const Logo = styled.img`
    height: 36px;
    min-width: 0;
    object-fit: contain;
`;

const Description = styled(Text18)`
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
`;

const Link = styled(Button).attrs({as: NavLink})`
    width: fit-content;
    padding: 16px 32px;
    background-color: #16A34A;
    font-size: 18px;
    line-height: 24px;
    font-weight: 500;

    @media (max-width: 768px) {
        font-size: 16px;
        line-height: 20px;
        padding: 14px 24px;
        margin-top: 15px;
    }
`;

const NewsCard = Object.assign(NewsCardRoot, {
    Header,
    Date: DateChip,
    Logos,
    Logo,
    Title: Text24W700,
    Description,
    Link,
});

export default NewsCard;
